import { useState } from 'react';
import type { Application } from '../types';
import { FunnelCard } from './FunnelCard';

interface CollapsedGroupProps {
  stage: 'rejected' | 'withdrawn';
  applications: Application[];
  jobId: number;
  onOpen: (applicationId: number) => void;
}

const config = {
  rejected:  { label: 'Rejected',  dot: 'bg-rose-400',  text: 'text-rose-700 dark:text-rose-400' },
  withdrawn: { label: 'Withdrawn', dot: 'bg-stone-400', text: 'text-stone-500 dark:text-gray-400' },
};

export function CollapsedGroup({ stage, applications, jobId, onOpen }: CollapsedGroupProps) {
  const [open, setOpen] = useState(false);
  const { label, dot, text } = config[stage];

  return (
    <div className="border border-stone-200 dark:border-gray-700 rounded-[10px] bg-white dark:bg-gray-800 overflow-hidden min-w-[220px] flex-shrink-0">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-3 hover:bg-stone-50 dark:hover:bg-gray-700 transition-colors text-left"
        aria-label={label}
      >
        <span className={`w-2 h-2 rounded-full flex-shrink-0 ${dot}`} />
        <span className={`text-[11px] font-bold tracking-widest uppercase ${text}`}>{label}</span>
        <span className="ml-1 text-[11px] font-semibold text-stone-400 dark:text-gray-500">{applications.length}</span>
        <span className={`ml-auto text-stone-400 dark:text-gray-500 text-xs transition-transform ${open ? 'rotate-90' : ''}`}>▸</span>
      </button>
      {open && applications.length > 0 && (
        <div className="px-3 pb-3 flex flex-col gap-2">
          {applications.map((app) => (
            <FunnelCard key={app.id} application={app} jobId={jobId} onOpen={onOpen} />
          ))}
        </div>
      )}
    </div>
  );
}
